// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".xYwvEYkcVfG26AbSTePOtA\\=\\={margin-right:var(--xds-spacing-a) !important;position:relative !important;top:1px !important}", "",{"version":3,"sources":["webpack://./src/pages/DeliveryDashboard/components/DashboardCustomTag/components/TagDelivered/TagDelivered.module.scss"],"names":[],"mappings":"AAAA,4BACI,4CAAA,CACA,4BAAA,CACA,kBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "xYwvEYkcVfG26AbSTePOtA=="
};
export default ___CSS_LOADER_EXPORT___;
